export const getMedicalCategories = () => {
  const medicalCategoriesData = [
    {
      category: "Hospital"
    },
    {
      category: "Clinic"
    },
    {
      category: "Diagnostic Center"
    },
    {
      category: "Laboratory"
    },
    {
      category: "Pharmacy"
    },
    {
      category: "Rehabilitation Center"
    },
    {
      category: "Specialty Center"
    },
    {
      category: "Public Health Facility"
    }
  ];

  return medicalCategoriesData;
};

export const getPractitionerCategories = () => {
  const practitionerCategoriesData = [
    {
      value: 0,
      label: "Medical"
    },
    {
      value: 1,
      label: "Non-Medical"
    }
  ];

  return practitionerCategoriesData;
};

export const getPractitionerGroup = () => {
  const practitionerGroup = [
    {
      label: "Non medical Staff",
      staffNumber: 584,
      staffPercentage: "51%"
    },
    {
      label: "Medical Staff",
      staffNumber: 100,
      staffPercentage: "20%"
    }
  ];

  return practitionerGroup;
};
